export default "<div #openseadragonContainer style=\"width: 100%; height: 500px;\"></div>\r\n";